
import React, { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazyLoad } from "./utils/lazyLoad";
import { prefetchResources } from "./utils/networkUtils";

const Index = lazyLoad(() => import(/* webpackPrefetch: true */ "./pages/Index"));
const Filters = lazyLoad(() => import("./pages/Filters"));
const UiFiliados = lazyLoad(() => import("./pages/UiFiliados"));
const TermosEPrivacidade = lazyLoad(() => import("./pages/TermosEPrivacidade"));
const TrabalheConosco = lazyLoad(() => import("./pages/TrabalheConosco"));
const NotFound = lazyLoad(() => import("./pages/NotFound"));

// Consultores pages
const ConsultoresIndex = lazyLoad(() => import("./pages/marketplace/ConsultoresIndex"));
const ConsultantDetail = lazyLoad(() => import("./pages/marketplace/ConsultantDetail"));
const CreateConsultantProfile = lazyLoad(() => import("./pages/marketplace/CreateConsultantProfile"));

const criticalPaths = [
  "/lovable-uploads/430d6f38-3c4c-4116-9707-d192bd8c40e6.png",
  "/lovable-uploads/b8e241ae-1602-455d-88c4-1087f3920338.png",
  "/lovable-uploads/6f956714-5071-4be0-8f07-47f285504b21.png"
];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

const App = () => {
  useEffect(() => {
    prefetchResources(criticalPaths);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/ui" element={<Filters />} />
            <Route path="/ui-filiados" element={<UiFiliados />} />
            <Route path="/termos-e-privacidade" element={<TermosEPrivacidade />} />
            <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
            
            {/* Consultores Routes */}
            <Route path="/consultores" element={<ConsultoresIndex />} />
            <Route path="/marketplace" element={<Navigate to="/consultores" replace />} />
            <Route path="/consultores/:id" element={<ConsultantDetail />} />
            <Route path="/consultores/profile/create" element={<CreateConsultantProfile />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
